class ProductTabs extends HTMLElement {
    constructor() {
        super();
        this.section = this.dataset.section;
        this.tabLinks = this.querySelectorAll('button[data-scroll]');
        this.tabContents = this.querySelectorAll('div[data-tab]');

        this.tabLinks.forEach((link) => {
            link.addEventListener('click', this.onButtonClick.bind(this));
        });

        this.firstActiveTabLink = this.querySelector('.product-tabs__tabs li:not([hidden])').querySelector('button')

        this.setActiveTab(this.firstActiveTabLink);
    }

    onButtonClick(event) {
        document.getElementById(`${this.section}-${event.target.dataset.scroll}`).scrollIntoView();
        this.setActiveTab(event.target);
        this.preventStickyHeader();
        
    }

    setActiveTab(tabLink) {
        this.removeActiveTabs();
        tabLink.classList.add('active');
    }

    removeActiveTabs() {
        this.tabLinks.forEach((link) => {
            link.classList.remove('active');
        });
    }

    preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }




}
customElements.define('product-tabs', ProductTabs);